import { Button } from './Button';
import Modal from './Modal';

export interface IConfirmationModalProps {
  title: string;
  text: string;
  confirmButtonText: string;
  cancelButtonText: string;
  titlePosition?: 'start' | 'center';
  secondaryText?: string;
  icon?: React.ReactElement;
  danger?: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  onClose?: () => void;
}

export default function ConfirmationModal({
  title,
  titlePosition = 'start',
  text,
  secondaryText,
  icon,
  confirmButtonText,
  cancelButtonText,
  danger = false,
  isLoading = false,
  onClose,
  onConfirm,
  onCancel,
}: IConfirmationModalProps) {
  return (
    <Modal
      title={title}
      titlePosition={titlePosition}
      onClose={onClose}
      className="max-w-sm"
    >
      <div className="mt-6 flex flex-col items-center justify-center gap-4">
        {icon && (
          <div className="rounded-full bg-red-50 p-3 dark:bg-red-900">
            {icon}
          </div>
        )}

        <div className="w-2/3 text-center tracking-tight">
          <strong>{text}</strong>

          {secondaryText && <p className="mt-2 text-sm">{secondaryText}</p>}
        </div>
        <div className="flex w-full gap-3">
          <Button
            className="h-9 w-auto flex-1 px-4 text-sm"
            color="ghost"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelButtonText}
          </Button>
          <Button
            className="h-9 w-auto flex-1 px-4 text-sm"
            color={danger ? 'danger' : 'primary'}
            onClick={onConfirm}
            isLoading={isLoading}
          >
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
